import styled, { css } from 'styled-components';
import { getRadius, getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { MAPPINGS_MODE, MAPPINGS_SCALE } from './Checkbox.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const CheckboxHidden = styled.input.attrs({ type: 'checkbox' }) `
  border: 0;
  clip: rect(0, 0, 0, 0);
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  height: 1px;
  width: 1px;
`;
export const CheckboxLabel = styled.label `
  ${({ scale, theme }) => {
    const { fontSize, fontWeight } = MAPPINGS_SCALE[scale];
    return css `
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      font-family: ${theme.typography.fontFamily};
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      gap: ${getSpace('s')};
      line-height: ${tokens.font.lineHeight.text.value};
    `;
}}
`;
export const CheckboxVisible = styled.div `
  ${({ checked: isChecked, disabled: isDisabled, mode }) => {
    const { background, border, checked, disabled, hover } = MAPPINGS_MODE[mode];
    return css `
      border-radius: ${getRadius('s')};
      cursor: pointer;
      flex-shrink: 0;
      height: ${getSpace('2xl')};
      position: relative;
      transition: 0.3s;
      width: ${getSpace('2xl')};

      /* Mode */
      background-color: ${background};
      border: 2px solid ${border};

      &:hover {
        border-color: ${hover.border};
      }

      &.error {
        border-color: ${tokens.colors.red[700].value};
      }

      ${isDisabled &&
        `
          background-color: ${disabled.background} !important;
          border-color: ${disabled.border} !important;
          color: ${disabled.text} !important;
          pointer-events: none;
        `}

      ${isChecked &&
        `
        background-color: ${checked.background};
        border-color: ${checked.border};
      `}

      &::after {
        background-color: transparent;
        border: 3px solid ${border};
        border-top: none;
        border-right: none;
        border-radius: 2px;
        content: '';
        height: 0.4rem;
        left: 50%;
        outline: 1px solid transparent;
        opacity: ${isChecked ? 1 : 0};
        position: absolute;
        top: 40%;
        transform: translate(-50%, -50%) rotate(-45deg);
        width: 0.8rem;
      }
    `;
}}
`;
export const CheckboxWrapper = styled.div `
  ${({ mode }) => {
    const { focus } = MAPPINGS_MODE[mode];
    return css `
      align-items: center;
      display: inline-flex;

      input[type='checkbox'] {
        &:focus + label ${CheckboxVisible} {
          border-color: ${focus.border};
          box-shadow: ${focus.shadow};
          outline: 0;
        }
      }
    `;
}}
`;
//# sourceMappingURL=Checkbox.styled.js.map